import { HelpListItem } from "../../components/modals/HowToPlayButton";

export function HowToPlayBody() {
  return (
    <div className="mt-2 text-md">
      <ul className="my-4 list-disc pl-4">
        <HelpListItem afterText="Try any 150+ game player since 2013" />
        <HelpListItem
          bgColor="bg-green-500"
          textColor="text-white"
          highlightText="Green in any column"
          afterText="indicates a match"
        />
        <HelpListItem
          bgColor="bg-yellow-200"
          highlightText={
            <>
              Yellow in the <strong>TEAM</strong> column
            </>
          }
          afterText="indicates the last team the player played for shares one or more colours"
        />
        <HelpListItem
          bgColor="bg-yellow-200"
          highlightText={
            <>
              Yellow in the <strong>POS</strong> column
            </>
          }
          afterText="indicates a partial match to the mystery player's position"
        />
        <HelpListItem
          bgColor="bg-yellow-200"
          highlightText="Yellow in any other column"
          afterText={
            <>
              indicates this attribute is <strong>within 3</strong> (teams
              played for, premierships won, year last played, guernsey number)
              of the mystery player
            </>
          }
        />
        <HelpListItem afterText="A new mystery legend every day!" />
      </ul>
    </div>
  );
}
